import { jsx as t, jsxs as w } from "react/jsx-runtime";
import _, { useEffect as K, useState as P, forwardRef as G, useRef as C, useCallback as $, useMemo as N, useLayoutEffect as Y } from "react";
var h = /* @__PURE__ */ ((e) => (e.XS = "XS", e.S = "S", e.M = "M", e.L = "L", e.XL = "XL", e))(h || {});
const U = Object.freeze({
  width: 14,
  height: 14,
  className: "min-w-[14px] min-h-[14px]",
  viewbox: "0 0 24 24",
  strokeWidth: 1.25
}), J = Object.freeze({
  width: 16,
  height: 16,
  className: "min-w-4 min-h-4",
  viewbox: "0 0 24 24",
  strokeWidth: 1.5
}), Q = Object.freeze({
  width: 20,
  height: 20,
  className: "min-w-5 min-h-5",
  viewbox: "0 0 24 24",
  strokeWidth: 1.75
}), E = Object.freeze({
  width: 24,
  height: 24,
  className: "min-w-6 min-h-6",
  viewbox: "0 0 24 24",
  strokeWidth: 1.75
}), ee = Object.freeze({
  width: 32,
  height: 32,
  className: "min-w-8 min-h-8",
  viewbox: "0 0 24 24",
  strokeWidth: 1.75
}), te = Object.freeze({
  XS: U,
  S: J,
  M: Q,
  L: E,
  XL: ee
});
var n = /* @__PURE__ */ ((e) => (e.Line = "line", e.Duo = "duo", e.Filled = "filled", e))(n || {}), o = /* @__PURE__ */ ((e) => (e.CurrentColor = "currentColor", e.Transparent = "transparent", e.Black = "#0E0E0E", e.White = "#FFFFFF", e.Indigo050 = "#F9F9FF", e.Indigo100 = "#F0EFFE", e.Indigo200 = "#DEDDFD", e.Indigo300 = "#BCB7FA ", e.Indigo400 = "#A29BF8", e.Indigo500 = "#867CF6", e.Indigo600 = "#675AF2", e.Indigo700 = "#581EEB ", e.Indigo800 = "#4216C5", e.Indigo900 = "#2D159D ", e.Green050 = "#EFFFF3", e.Green100 = "#DEFEE7", e.Green200 = "#B8FECC", e.Green300 = "#70FDA1", e.Green400 = "#38DF7D", e.Green500 = "#2BB464", e.Green600 = "#229451", e.Green700 = "#1A7A42", e.Green800 = "#11552E", e.Green900 = "#0C3C20", e.Yellow050 = "#FFFBE9", e.Yellow100 = "#FEF7D0", e.Yellow200 = "#FEF090", e.Yellow300 = "#F7E541", e.Yellow400 = "#D6C137", e.Yellow500 = "#AD992A", e.Yellow600 = "#8E7C21", e.Yellow700 = "#756619", e.Yellow800 = "#554811", e.Yellow900 = "#372F0B", e.Red050 = "#FFF8F8", e.Red100 = "#FEEDED", e.Red200 = "#FDD7D8", e.Red300 = "#FBA8AB", e.Red400 = "#FA8288", e.Red500 = "#F94C58", e.Red600 = "#DF1D33", e.Red700 = "#B21527", e.Red800 = "#8A0F1D", e.Red900 = "#660A15", e.Khaki025 = "#FAFAFA", e.Khaki050 = "#F6F5F3", e.Khaki100 = "#EEECE8", e.Khaki150 = "#E5E2DC", e.Khaki200 = "#DCD9D0", e.Khaki300 = "#CBC6B9", e.Khaki400 = "#B1A995", e.Khaki500 = "#978C72", e.Khaki600 = "#756C57", e.Khaki700 = "#5E5645", e.Khaki800 = "#464134", e.Khaki900 = "#2F2B23", e.Orange050 = "#FFF8F7 ", e.Orange100 = "#F9E8E6", e.Orange200 = "#F3CFC9", e.Orange300 = "#EBA291", e.Orange400 = "#E47E61", e.Orange500 = "#D15E2B", e.Orange600 = "#AB5025", e.Orange700 = "#8A4321", e.Orange800 = "#6C391F", e.Orange900 = "#56321E", e.Pink050 = "#FDF8FF", e.Pink100 = "#F3E8F8", e.Pink200 = "#E7D0F2", e.Pink300 = "#D7A3E8", e.Pink400 = "#C981DF", e.Pink500 = "#BF5AD5", e.Pink600 = "#A832C3", e.Pink700 = "#872D99", e.Pink800 = "#722B7E", e.Pink900 = "#612967", e.Teal050 = "#EDFAFA", e.Teal100 = "#D5F5F6", e.Teal200 = "#AFECEF", e.Teal300 = "#7EDCE2", e.Teal400 = "#16BDCA", e.Teal500 = "#0694A2", e.Teal600 = "#047481", e.Teal700 = "#036672", e.Teal800 = "#05505C", e.Teal900 = "#014451", e))(o || {});
const Tn = ({
  Component: e,
  style: i = n.Line,
  size: r = h.M,
  color: s = o.Black
}) => {
  const a = te[r];
  return /* @__PURE__ */ t("span", { className: a.className, children: /* @__PURE__ */ t(e, { ...a, size: r, stroke: s, fill: s, color: s, style: i }) });
}, ne = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "m10.5 3.5-7 7m0-7 7 7" }) }), re = ne, oe = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "m10.5 3.5-7 7m0-7 7 7" }) }), ie = oe, le = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "m12 4-8 8m0-8 8 8" }) }), se = le, he = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "m12 4-8 8m0-8 8 8" }) }), ae = he, ce = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M15 5 5 15M5 5l10 10" }) }), de = ce, we = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M15 5 5 15M5 5l10 10" }) }), ge = we, ue = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M18 6 6 18M6 6l12 12" }) }), F = ue, pe = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "M18 6 6 18M6 6l12 12" }) }), D = pe, ke = {
  [h.XS]: {
    [n.Line]: (e) => /* @__PURE__ */ t(re, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(ie, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.S]: {
    [n.Line]: (e) => /* @__PURE__ */ t(se, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(ae, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.M]: {
    [n.Line]: (e) => /* @__PURE__ */ t(de, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(ge, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.L]: {
    [n.Line]: (e) => /* @__PURE__ */ t(F, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(D, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.XL]: {
    [n.Line]: (e) => /* @__PURE__ */ t(F, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(D, { color: e }),
    [n.Filled]: (e) => null
  }
}, jn = ({ size: e, style: i, color: r }) => ke[e][i](r), ve = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M7 5.25v2.333m0 2.334h.006M7 1.458 1.167 11.667h11.666z"
  }
) }), fe = ve, Le = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: [
  /* @__PURE__ */ t(
    "path",
    {
      fill: e,
      d: "M1.395 10.557 6.192 2.27c.266-.458.398-.687.571-.764a.58.58 0 0 1 .474 0c.173.077.306.306.57.764l4.799 8.287c.266.46.399.69.38.878a.58.58 0 0 1-.238.412c-.153.111-.419.111-.95.111H2.202c-.53 0-.796 0-.95-.111a.58.58 0 0 1-.237-.412c-.02-.188.113-.418.38-.878",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: "1.25",
      d: "M7 5.25v2.333m0 2.334h.006M7 1.458 1.167 11.667h11.666z"
    }
  )
] }), Ce = Le, $e = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M8 6v2.667m0 2.666h.007M8 1.667 1.334 13.333h13.333z"
  }
) }), Fe = $e, De = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: [
  /* @__PURE__ */ t(
    "path",
    {
      fill: e,
      d: "m1.594 12.066 5.483-9.471c.303-.524.454-.786.652-.874a.67.67 0 0 1 .542 0c.198.088.35.35.652.874l5.483 9.47c.304.526.457.789.434 1.004a.67.67 0 0 1-.27.47c-.176.128-.48.128-1.087.128H2.517c-.607 0-.91 0-1.086-.128a.67.67 0 0 1-.271-.47c-.023-.215.13-.478.434-1.003",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      d: "M8 6v2.667m0 2.666h.007M8 1.667 1.334 13.333h13.333z"
    }
  )
] }), me = De, Me = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: "1.75",
    d: "M10 7.5v3.333m0 3.334h.008M10 2.083 1.667 16.667h16.666z"
  }
) }), xe = Me, We = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: [
  /* @__PURE__ */ t(
    "path",
    {
      fill: e,
      d: "M1.992 15.082 8.846 3.243c.379-.654.568-.981.816-1.091a.83.83 0 0 1 .677 0c.247.11.436.437.815 1.091l6.854 11.839c.38.657.57.985.542 1.254a.83.83 0 0 1-.338.588c-.22.16-.599.16-1.358.16H3.146c-.759 0-1.138 0-1.357-.16a.83.83 0 0 1-.339-.588c-.028-.27.162-.597.542-1.254",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: "1.75",
      d: "M10 7.5v3.333m0 3.334h.008M10 2.083 1.667 16.667h16.666z"
    }
  )
] }), qe = We, ye = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: "1.75",
    d: "M12 9v4m0 4h.01M12 2.5 2 20h20z"
  }
) }), m = ye, Se = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ t(
    "path",
    {
      fill: e,
      d: "m2.39 18.098 8.226-14.206c.454-.785.681-1.178.978-1.31a1 1 0 0 1 .813 0c.296.132.523.525.978 1.31l8.225 14.206c.456.788.684 1.182.65 1.506a1 1 0 0 1-.406.705c-.263.191-.718.191-1.629.191H3.775c-.91 0-1.365 0-1.628-.191a1 1 0 0 1-.407-.705c-.034-.324.194-.718.65-1.506",
      opacity: ".12"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: "1.75",
      d: "M12 9v4m0 4h.01M12 2.5 2 20h20z"
    }
  )
] }), M = Se, Ae = {
  [h.XS]: {
    [n.Line]: (e) => /* @__PURE__ */ t(fe, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(Ce, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.S]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Fe, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(me, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.M]: {
    [n.Line]: (e) => /* @__PURE__ */ t(xe, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(qe, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.L]: {
    [n.Line]: (e) => /* @__PURE__ */ t(m, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(M, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.XL]: {
    [n.Line]: (e) => /* @__PURE__ */ t(m, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(M, { color: e }),
    [n.Filled]: (e) => null
  }
}, In = ({ size: e, style: i, color: r }) => Ae[e][i](r), be = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "M3.5 5.25 7 8.75l3.5-3.5" }) }), Oe = be, Xe = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "M3.5 5.25 7 8.75l3.5-3.5" }) }), Re = Xe, Ze = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "m4 6 4 4 4-4" }) }), Be = Ze, Te = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "m4 6 4 4 4-4" }) }), je = Te, Ie = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m5 7.5 5 5 5-5" }) }), ze = Ie, Ve = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m5 7.5 5 5 5-5" }) }), _e = Ve, He = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m6 9 6 6 6-6" }) }), x = He, Ke = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m6 9 6 6 6-6" }) }), W = Ke, Pe = {
  [h.XS]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Oe, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(Re, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.S]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Be, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(je, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.M]: {
    [n.Line]: (e) => /* @__PURE__ */ t(ze, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(_e, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.L]: {
    [n.Line]: (e) => /* @__PURE__ */ t(x, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(W, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.XL]: {
    [n.Line]: (e) => /* @__PURE__ */ t(x, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(W, { color: e }),
    [n.Filled]: (e) => null
  }
}, zn = ({ size: e, style: i, color: r }) => Pe[e][i](r), Ge = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "M10.5 8.75 7 5.25l-3.5 3.5" }) }), Ne = Ge, Ye = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "M10.5 8.75 7 5.25l-3.5 3.5" }) }), Ue = Ye, Je = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "M12 10 8 6l-4 4" }) }), Qe = Je, Ee = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "M12 10 8 6l-4 4" }) }), et = Ee, tt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m15 12.5-5-5-5 5" }) }), nt = tt, rt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m15 12.5-5-5-5 5" }) }), ot = rt, it = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m18 15-6-6-6 6" }) }), q = it, lt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m18 15-6-6-6 6" }) }), y = lt, st = {
  [h.XS]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Ne, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(Ue, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.S]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Qe, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(et, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.M]: {
    [n.Line]: (e) => /* @__PURE__ */ t(nt, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(ot, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.L]: {
    [n.Line]: (e) => /* @__PURE__ */ t(q, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(y, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.XL]: {
    [n.Line]: (e) => /* @__PURE__ */ t(q, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(y, { color: e }),
    [n.Filled]: (e) => null
  }
}, Vn = ({ size: e, style: i, color: r }) => st[e][i](r);
function ht(e) {
  K(e, []);
}
function _n() {
  const [e, i] = P({
    width: void 0,
    height: void 0
  });
  return ht(() => {
    function r() {
      i({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", r), r(), () => window.removeEventListener("resize", r);
  }), e;
}
var f = function() {
  return f = Object.assign || function(i) {
    for (var r, s = 1, a = arguments.length; s < a; s++) {
      r = arguments[s];
      for (var l in r)
        Object.prototype.hasOwnProperty.call(r, l) && (i[l] = r[l]);
    }
    return i;
  }, f.apply(this, arguments);
};
function S(e, i) {
  var r = {};
  for (var s in e)
    Object.prototype.hasOwnProperty.call(e, s) && i.indexOf(s) < 0 && (r[s] = e[s]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, s = Object.getOwnPropertySymbols(e); a < s.length; a++)
      i.indexOf(s[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, s[a]) && (r[s[a]] = e[s[a]]);
  return r;
}
function Hn(e, i, r, s) {
  function a(l) {
    return l instanceof r ? l : new r(function(d) {
      d(l);
    });
  }
  return new (r || (r = Promise))(function(l, d) {
    function g(u) {
      try {
        c(s.next(u));
      } catch (v) {
        d(v);
      }
    }
    function p(u) {
      try {
        c(s.throw(u));
      } catch (v) {
        d(v);
      }
    }
    function c(u) {
      u.done ? l(u.value) : a(u.value).then(g, p);
    }
    c((s = s.apply(e, i || [])).next());
  });
}
function Kn(e, i) {
  var r = { label: 0, sent: function() {
    if (l[0] & 1)
      throw l[1];
    return l[1];
  }, trys: [], ops: [] }, s, a, l, d;
  return d = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (d[Symbol.iterator] = function() {
    return this;
  }), d;
  function g(c) {
    return function(u) {
      return p([c, u]);
    };
  }
  function p(c) {
    if (s)
      throw new TypeError("Generator is already executing.");
    for (; d && (d = 0, c[0] && (r = 0)), r; )
      try {
        if (s = 1, a && (l = c[0] & 2 ? a.return : c[0] ? a.throw || ((l = a.return) && l.call(a), 0) : a.next) && !(l = l.call(a, c[1])).done)
          return l;
        switch (a = 0, l && (c = [c[0] & 2, l.value]), c[0]) {
          case 0:
          case 1:
            l = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (l = r.trys, !(l = l.length > 0 && l[l.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!l || c[1] > l[0] && c[1] < l[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < l[1]) {
              r.label = l[1], l = c;
              break;
            }
            if (l && r.label < l[2]) {
              r.label = l[2], r.ops.push(c);
              break;
            }
            l[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = i.call(e, r);
      } catch (u) {
        c = [6, u], a = 0;
      } finally {
        s = l = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function Pn(e, i) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var s = r.call(e), a, l = [], d;
  try {
    for (; (i === void 0 || i-- > 0) && !(a = s.next()).done; )
      l.push(a.value);
  } catch (g) {
    d = { error: g };
  } finally {
    try {
      a && !a.done && (r = s.return) && r.call(s);
    } finally {
      if (d)
        throw d.error;
    }
  }
  return l;
}
function Gn(e, i, r) {
  if (r || arguments.length === 2)
    for (var s = 0, a = i.length, l; s < a; s++)
      (l || !(s in i)) && (l || (l = Array.prototype.slice.call(i, 0, s)), l[s] = i[s]);
  return e.concat(l || Array.prototype.slice.call(i));
}
function at(e) {
  var i = function(s, a) {
    return _.createElement(e, f({}, s, { forwardedRef: a }));
  }, r = e.displayName || e.name;
  return i.displayName = "withForwardedRef(" + r + ")", G(i);
}
var A = Object.keys, ct = function(i, r) {
  if (i === r)
    return !0;
  if (!(i instanceof Object) || !(r instanceof Object))
    return !1;
  for (var s = A(i), a = s.length, l = 0; l < a; l++)
    if (!(s[l] in r))
      return !1;
  for (var l = 0; l < a; l++)
    if (i[s[l]] !== r[s[l]])
      return !1;
  return a === A(r).length;
}, dt = function(e, i) {
  var r = window.getComputedStyle(i), s = r.borderBottomWidth, a = r.borderTopWidth, l = r.fontSize, d = r.lineHeight, g = r.paddingBottom, p = r.paddingTop, c = d === "normal" ? parseFloat(l) * 1.2 : parseFloat(d), u = e === 0 ? 0 : c * e + parseFloat(s) + parseFloat(a) + parseFloat(g) + parseFloat(p), v = i.scrollHeight + parseFloat(s) + parseFloat(a);
  return Math.max(u, v);
}, L = function(e, i) {
  if (i) {
    var r = "hidden", s = window.getComputedStyle(i).maxHeight;
    if (s !== "none") {
      var a = parseFloat(s);
      a < i.scrollHeight && (r = "");
    }
    i.style.height = "0", i.style.overflowY = r, i.style.height = "".concat(dt(e, i), "px");
  }
}, wt = function(e) {
  var i = C(e), r = C(0);
  return ct(e, i.current) || (i.current = e, r.current += 1), N(function() {
    return i.current;
  }, [r.current]);
}, b = typeof window > "u" ? Function.prototype : Y, gt = function(e) {
  var i = e.forwardedRef, r = S(e, ["forwardedRef"]), s = typeof i == "function", a = wt(r.style), l = C(), d = s || !i ? l : i, g = r.rows ? parseInt("" + r.rows, 10) : 0, p = r.onChange, c = r.onInput, u = S(r, ["onChange", "onInput"]);
  b(function() {
    L(g, d.current);
  }, [r.className, r.value, d, g, a]), b(function() {
    if (window.ResizeObserver) {
      var k = new ResizeObserver(function() {
        L(g, d.current);
      });
      return k.observe(d.current), function() {
        k.disconnect();
      };
    }
  }, [d, g]);
  var v = $(function(k) {
    p?.(k), c?.(k), L(g, d.current);
  }, [p, c, d, g]), H = $(function(k) {
    d.current = k, s && i(k);
  }, [i, s, d]);
  return _.createElement("textarea", f({}, u, { onInput: v, ref: H, rows: g }));
};
const Nn = at(gt), ut = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t("g", { children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.25",
    d: "M7 4.667V7m0 2.333h.006M12.833 7A5.833 5.833 0 1 1 1.166 7a5.833 5.833 0 0 1 11.667 0Z"
  }
) }) }), pt = ut, kt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ w("g", { children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M7 12.833A5.833 5.833 0 1 0 7 1.167a5.833 5.833 0 0 0 0 11.666", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.25",
      d: "M7 4.667V7m0 2.333h.006M12.833 7A5.833 5.833 0 1 1 1.166 7a5.833 5.833 0 0 1 11.667 0Z"
    }
  )
] }) }), vt = kt, ft = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t("g", { children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.5",
    d: "M8 5.333V8m0 2.667h.007M14.667 8A6.667 6.667 0 1 1 1.334 8a6.667 6.667 0 0 1 13.333 0Z"
  }
) }) }), Lt = ft, Ct = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ w("g", { children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.5",
      d: "M8 5.333V8m0 2.667h.007M14.667 8A6.667 6.667 0 1 1 1.334 8a6.667 6.667 0 0 1 13.333 0Z"
    }
  )
] }) }), $t = Ct, Ft = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t("g", { children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "M10 6.667V10m0 3.333h.008M18.333 10a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0Z"
  }
) }) }), Dt = Ft, mt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ w("g", { children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M10 6.667V10m0 3.333h.008M18.333 10a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0Z"
    }
  )
] }) }), Mt = mt, xt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "M12 8v4m0 4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }
) }), O = xt, Wt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M12 8v4m0 4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
    }
  )
] }), X = Wt, qt = {
  [h.XS]: {
    [n.Line]: (e) => /* @__PURE__ */ t(pt, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(vt, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.S]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Lt, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t($t, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.M]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Dt, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(Mt, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.L]: {
    [n.Line]: (e) => /* @__PURE__ */ t(O, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(X, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.XL]: {
    [n.Line]: (e) => /* @__PURE__ */ t(O, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(X, { color: e }),
    [n.Filled]: (e) => null
  }
}, Yn = ({ size: e, style: i, color: r }) => qt[e][i](r), yt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t("g", { children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.25",
    d: "M7 9.333V7m0-2.333h.006M12.833 7A5.833 5.833 0 1 1 1.166 7a5.833 5.833 0 0 1 11.667 0Z"
  }
) }) }), St = yt, At = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ w("g", { children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M7 12.833A5.833 5.833 0 1 0 7 1.167a5.833 5.833 0 0 0 0 11.666", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.25",
      d: "M7 9.333V7m0-2.333h.006M12.833 7A5.833 5.833 0 1 1 1.166 7a5.833 5.833 0 0 1 11.667 0Z"
    }
  )
] }) }), bt = At, Ot = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t("g", { children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.5",
    d: "M8 10.667V8m0-2.667h.007M14.667 8A6.667 6.667 0 1 1 1.334 8a6.667 6.667 0 0 1 13.333 0Z"
  }
) }) }), Xt = Ot, Rt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ w("g", { children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.5",
      d: "M8 10.667V8m0-2.667h.007M14.667 8A6.667 6.667 0 1 1 1.334 8a6.667 6.667 0 0 1 13.333 0Z"
    }
  )
] }) }), Zt = Rt, Bt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t("g", { children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "M10 13.333V10m0-3.333h.008M18.333 10a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0Z"
  }
) }) }), Tt = Bt, jt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ w("g", { children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M10 13.333V10m0-3.333h.008M18.333 10a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0Z"
    }
  )
] }) }), It = jt, zt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "M12 16v-4m0-4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }
) }), R = zt, Vt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "M12 16v-4m0-4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
    }
  )
] }), Z = Vt, _t = {
  [h.XS]: {
    [n.Line]: (e) => /* @__PURE__ */ t(St, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(bt, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.S]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Xt, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(Zt, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.M]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Tt, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(It, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.L]: {
    [n.Line]: (e) => /* @__PURE__ */ t(R, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(Z, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.XL]: {
    [n.Line]: (e) => /* @__PURE__ */ t(R, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(Z, { color: e }),
    [n.Filled]: (e) => null
  }
}, Un = ({ size: e, style: i, color: r }) => _t[e][i](r), Ht = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "M5.25 10.5 8.75 7l-3.5-3.5" }) }), Kt = Ht, Pt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.25", d: "M5.25 10.5 8.75 7l-3.5-3.5" }) }), Gt = Pt, Nt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "m6 12 4-4-4-4" }) }), Yt = Nt, Ut = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.5", d: "m6 12 4-4-4-4" }) }), Jt = Ut, Qt = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m7.5 15 5-5-5-5" }) }), Et = Qt, en = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m7.5 15 5-5-5-5" }) }), tn = en, nn = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m9 18 6-6-6-6" }) }), B = nn, rn = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m9 18 6-6-6-6" }) }), T = rn, on = {
  [h.XS]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Kt, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(Gt, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.S]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Yt, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(Jt, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.M]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Et, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(tn, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.L]: {
    [n.Line]: (e) => /* @__PURE__ */ t(B, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(T, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.XL]: {
    [n.Line]: (e) => /* @__PURE__ */ t(B, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(T, { color: e }),
    [n.Filled]: (e) => null
  }
}, Jn = ({ size: e, style: i, color: r }) => on[e][i](r), ln = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.25",
    d: "m12.25 12.25-3.5-3.5m1.167-2.917a4.083 4.083 0 1 1-8.167 0 4.083 4.083 0 0 1 8.167 0Z"
  }
) }), sn = ln, hn = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M5.833 9.917a4.083 4.083 0 1 0 0-8.167 4.083 4.083 0 0 0 0 8.167", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.25",
      d: "m12.25 12.25-3.5-3.5m1.167-2.917a4.083 4.083 0 1 1-8.167 0 4.083 4.083 0 0 1 8.167 0Z"
    }
  )
] }), an = hn, cn = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.5",
    d: "m14 14-4-4m1.333-3.333a4.667 4.667 0 1 1-9.333 0 4.667 4.667 0 0 1 9.333 0Z"
  }
) }), dn = cn, wn = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M6.667 11.333a4.667 4.667 0 1 0 0-9.333 4.667 4.667 0 0 0 0 9.333", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.5",
      d: "m14 14-4-4m1.333-3.333a4.667 4.667 0 1 1-9.333 0 4.667 4.667 0 0 1 9.333 0Z"
    }
  )
] }), gn = wn, un = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "m17.5 17.5-5-5m1.667-4.167a5.833 5.833 0 1 1-11.667 0 5.833 5.833 0 0 1 11.667 0Z"
  }
) }), pn = un, kn = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M8.333 14.167a5.833 5.833 0 1 0 0-11.667 5.833 5.833 0 0 0 0 11.667", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "m17.5 17.5-5-5m1.667-4.167a5.833 5.833 0 1 1-11.667 0 5.833 5.833 0 0 1 11.667 0Z"
    }
  )
] }), vn = kn, fn = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" }) }), j = fn, Ln = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14", opacity: ".12" }),
  /* @__PURE__ */ t("path", { stroke: e, strokeLinecap: "square", strokeWidth: "1.75", d: "m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" })
] }), I = Ln, Cn = {
  [h.XS]: {
    [n.Line]: (e) => /* @__PURE__ */ t(sn, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(an, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.S]: {
    [n.Line]: (e) => /* @__PURE__ */ t(dn, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(gn, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.M]: {
    [n.Line]: (e) => /* @__PURE__ */ t(pn, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(vn, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.L]: {
    [n.Line]: (e) => /* @__PURE__ */ t(j, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(I, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.XL]: {
    [n.Line]: (e) => /* @__PURE__ */ t(j, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(I, { color: e }),
    [n.Filled]: (e) => null
  }
}, Qn = ({ size: e, style: i, color: r }) => Cn[e][i](r), $n = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ t("g", { children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.25",
    d: "m4.375 7 1.75 1.75 3.5-3.5M12.833 7A5.833 5.833 0 1 1 1.167 7a5.833 5.833 0 0 1 11.666 0Z"
  }
) }) }), Fn = $n, Dn = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", children: /* @__PURE__ */ w("g", { children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M7 12.833A5.833 5.833 0 1 0 7 1.167a5.833 5.833 0 0 0 0 11.666", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.25",
      d: "m4.375 7 1.75 1.75 3.5-3.5M12.833 7A5.833 5.833 0 1 1 1.167 7a5.833 5.833 0 0 1 11.666 0Z"
    }
  )
] }) }), mn = Dn, Mn = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ t("g", { children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.5",
    d: "m5 8 2 2 4-4m3.667 2A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0Z"
  }
) }) }), xn = Mn, Wn = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ w("g", { children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.5",
      d: "m5 8 2 2 4-4m3.667 2A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0Z"
    }
  )
] }) }), qn = Wn, yn = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ t("g", { children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "m6.25 10 2.5 2.5 5-5m4.583 2.5a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0Z"
  }
) }) }), Sn = yn, An = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", children: /* @__PURE__ */ w("g", { children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "m6.25 10 2.5 2.5 5-5m4.583 2.5a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0Z"
    }
  )
] }) }), bn = An, On = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: /* @__PURE__ */ t(
  "path",
  {
    stroke: e,
    strokeLinecap: "square",
    strokeWidth: "1.75",
    d: "m7.5 12 3 3 6-6m5.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
  }
) }), z = On, Xn = ({ color: e = o.CurrentColor }) => /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", children: [
  /* @__PURE__ */ t("path", { fill: e, d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10", opacity: ".12" }),
  /* @__PURE__ */ t(
    "path",
    {
      stroke: e,
      strokeLinecap: "square",
      strokeWidth: "1.75",
      d: "m7.5 12 3 3 6-6m5.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
    }
  )
] }), V = Xn, Rn = {
  [h.XS]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Fn, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(mn, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.S]: {
    [n.Line]: (e) => /* @__PURE__ */ t(xn, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(qn, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.M]: {
    [n.Line]: (e) => /* @__PURE__ */ t(Sn, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(bn, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.L]: {
    [n.Line]: (e) => /* @__PURE__ */ t(z, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(V, { color: e }),
    [n.Filled]: (e) => null
  },
  [h.XL]: {
    [n.Line]: (e) => /* @__PURE__ */ t(z, { color: e }),
    [n.Duo]: (e) => /* @__PURE__ */ t(V, { color: e }),
    [n.Filled]: (e) => null
  }
}, En = ({ size: e, style: i, color: r }) => Rn[e][i](r);
export {
  h as A,
  o as C,
  Nn as E,
  Tn as I,
  Qn as S,
  jn as X,
  f as _,
  In as a,
  n as b,
  Vn as c,
  zn as d,
  Un as e,
  Yn as f,
  Jn as g,
  _n as h,
  En as i,
  S as j,
  Gn as k,
  Hn as l,
  Kn as m,
  Pn as n,
  ht as u
};
